import { useMutation } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useTags() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useAssignTags() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/tags/assign`, parameters).then(parseSuccessResponseData),
        });
    }

    function useGetEntityTags() {
        return useMutation({
            mutationFn: (parameters: { entityType: string; entityId: string }) =>
                axiosPrivate
                    .get(`/v1/tags/${parameters.entityType}/${parameters.entityId}`)
                    .then(parseSuccessResponseData),
        });
    }

    function useSearchByTags() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.get(`/v1/tags/search`, { params: parameters }).then(parseSuccessResponseData),
        });
    }

    function useDeleteEntityTags() {
        return useMutation({
            mutationFn: (parameters: { entityType: string; entityId: string; tagKeys?: string[] }) =>
                axiosPrivate
                    .delete(`/v1/tags/${parameters.entityType}/${parameters.entityId}`, {
                        data: { TagKeys: parameters.tagKeys },
                    })
                    .then(parseSuccessResponseData),
        });
    }

    return { useAssignTags, useGetEntityTags, useSearchByTags, useDeleteEntityTags };
}
